<template>
  <div class="blocked-cashflow-view">
    <div class="traffic-light-line">
      <div class="labeled-line">
        <img class="triangle" :src="require('@/assets/icons/right-triangle.svg')">
        <div class="label disabled">
          {{ fullMonthName }}
        </div>
        <div class="line disabled"></div>
        <div class="circle disabled"></div>
      </div>
    </div>
    <div class="blocked-cashflow-view-container">
      <expected-end-of-month />
      <riseup-goal/>
      <cashflow-type-variable-expense />
      <cashflow-type-economy/>
      <cashflow-type-fixed-expense/>
      <cashflow-type-income/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Segment from '../../../../../../../Segment';
import ExpectedEndOfMonth from './components/ExpectedEndOfMonth.vue';
import RiseupGoal from './components/RiseupGoal.vue';
import CashflowTypeIncome from './components/types/CashflowTypeIncome.vue';
import CashflowTypeVariableExpense from './components/types/CashflowTypeVariableExpense.vue';
import CashflowTypeEconomy from './components/types/CashflowTypeEconomy.vue';
import CashflowTypeFixedExpense from './components/types/CashflowTypeFixedExpense.vue';

export default {
  name: 'BlockedCashflowView',
  components: {
    ExpectedEndOfMonth,
    RiseupGoal,
    CashflowTypeIncome,
    CashflowTypeVariableExpense,
    CashflowTypeEconomy,
    CashflowTypeFixedExpense,
  },
  async created() {
    Segment.trackUserGot('BlockedCashflowViewEntered');
  },
  computed: {
    ...mapGetters('cashflowView', ['fullMonthName']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../scss/mixins';

  .blocked-cashflow-view {
    opacity: 0.15;

    .traffic-light-line {
      @include responsive-padding;
      width: 100%;
      text-align: center;
      margin-bottom: 11px;

      .labeled-line {
        width: 100%;
        padding-top: 12px;
        position: relative;
        display: inline-block;

        .disabled {
          background-color: $riseup_gray_2;
        }

        .label {
          height: 18px;
          line-height: 15px;
          font-size: 14px;
          padding: 2px 4px 2px 4px;
          display: inline-block;
          color: $riseup_white;
          font-weight: bold;
          position: absolute;
          right: 0;
          top: -3px;
        }

        .line {
          height: 3px;
        }

        .circle {
          position: absolute;
          left: 0;
          top: 5px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          display: inline-block;
        }

        .triangle {
          position: absolute;
          right: -20px;
          top: -4px;
        }
      }
    }

    .blocked-cashflow-view-container {
      @include responsive-padding;
      font-family: SimplerPro;
      text-align: right;
      width: 100%;
      margin: 0 auto;
    }
  }
</style>
